import http from './api';

const BASE_URL = 'api/proactive-chat-configurations';

const getConfigurations = orgId => http.get(`${BASE_URL}`, { params: { orgId } });
const getConfiguration = proactiveChatConfigurationId => http.get(`${BASE_URL}/${proactiveChatConfigurationId}`);
const createConfiguration = proactiveChatConfiguration => http.post(`${BASE_URL}`, proactiveChatConfiguration);
const deleteConfiguration = proactiveChatConfigurationId => http.delete(`${BASE_URL}/${proactiveChatConfigurationId}`);
const updateConfiguration = (proactiveChatConfigurationId, proactiveChatConfiguration) =>
  http.put(`${BASE_URL}/${proactiveChatConfigurationId}`, proactiveChatConfiguration);

export default {
  getConfiguration,
  getConfigurations,
  createConfiguration,
  deleteConfiguration,
  updateConfiguration
};
